var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgShareFolder(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "shareFolder",
    transform: "translate(11340 -2321.525)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1309",
    "data-name": "Ellipse 1309",
    cx: 25,
    cy: 25,
    r: 25,
    transform: "translate(-11340 2321.525)",
    fill: "#474461"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34553",
    "data-name": "Path 34553",
    d: "M17.667,10.333V5L27,14.333l-9.333,9.333V18.2C11,18.2,6.333,20.333,3,25,4.333,18.333,8.333,11.667,17.667,10.333Z",
    transform: "translate(-11330 2331.156)",
    fill: "#fff"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgShareFolder);
export default __webpack_public_path__ + "static/media/shareFolder.5571857dd43cc59dea5ed0747d1eefd6.svg";
export { ForwardRef as ReactComponent };